var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-expansion-panels',{attrs:{"accordion":""}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',[_c('span',{staticClass:"subtitle-1"},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-cogs ")]),_vm._v(" Activity Configuration ")],1)]),_c('v-expansion-panel-content',{staticClass:"requirement-config"},[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }